export const text = {
  newProduct: 'Nuevo producto',
  addProduct: 'Guardar producto',
  subheader: 'Agrega los detalles que definirán tu producto',
  productCreated: 'Se ha creado el producto.',
  productError: 'Ha ocurrido un error el cargar tu producto',
  editProduct: 'Editar producto'
};
